// Liste à conserver À JOUR avec les noms des assureurs tels que définis par la convention interne
// (ex: backend/node/upptec/cli/commands/dumpCategoriesMapping.ts -> enum Insurer)
export var InsurerName;
(function (InsurerName) {
    InsurerName["Claims"] = "claims";
    InsurerName["Lite"] = "lite";
    InsurerName["Integral"] = "integral";
    InsurerName["BPCE"] = "bpce";
})(InsurerName || (InsurerName = {}));
